
























import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DocumentSignatureDynamicTemplate from "@/shared/components/DocumentSignatureDynamicTemplate.vue";
import { FetchState, SigningDocumentContentType } from "@/shared/types";
import moment from "moment";
import { useNotifierStore } from "@/shared/store/notifier";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { isMobileApp } from "@/shared/mobileHelper";

@Component({
  components: {
    GenericLoadingSpinner,
    DocumentSignatureDynamicTemplate
  }
})
export default class DocumentView extends Vue {
  notifierStore = useNotifierStore();
  signingDocumentStore = useSigningDocumentStore();

  @Prop()
  documentKey: string;

  @Prop()
  print: boolean;

  SigningDocumentContentType = SigningDocumentContentType;
  moment = moment;
  dynamicTemplateData = {};

  mounted () {
    this.signingDocumentStore.getDocumentLatestVersion(this.documentKey);
  }

  @Watch("signingDocumentStore.documentFetchState", { deep: true })
  onDocumentFetchStateChange () {
    if (this.print && this.signingDocumentStore.isDocumentLoaded) {
      setTimeout(() => {
        window.print();
      }, 1000);
    }
  }

  get isMobile () {
    return isMobileApp();
  }
}
